angular.module('unergie.main')
.directive('salesTunnelAccountCategoryV3', (DraftsBasic, ErrorCatcher, MetaWatcher) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        disableContractEdition: '=',
    },
    templateUrl: '/states/salesTunnelV3/component/salesTunnelAccountCategoryV3.html',
    link($scope) {
        $scope.form = {}

        // VALIDATORS
        const initComponentValidator = () =>
            MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                isAccountCategoryDefined(store) {
                    return ['part', 'small-business'].includes(store.draft.account_category)
                },
            })

        $scope.$watch('draft', (draft) => {
            $scope.form = {
                account_category: _.get(draft, 'account_category', undefined),
            }
        })

        $scope.changeAccountCategory = () => {
            DraftsBasic.changeDraftAccountCategory({ id_draft_basic: $scope.draft.id }, { account_category: $scope.form.account_category })
            .$promise.catch(ErrorCatcher)
            .finally(() => {
                MetaWatcher.notif('SALES_TUNNEL.RELOAD_DRAFT', {})
            })
        }

        const activate = initComponentValidator
        activate()
    },
}))
